module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_c('strong', [_vm._v("Illustrations")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2a0",
    attrs: {
      "id": "sec2-1"
    }
  }, [_vm._v("Figures")]), _vm._v(" "), _c('p', {
    staticClass: "fig-list"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter01#fig1-1"
    }
  }, [_vm._v("1.1")]), _c('span', {
    staticClass: "sp"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter01#fig1-1"
    }
  }, [_vm._v("The annunciation as depicted in the medieval "), _c('em', [_vm._v("Biblia Pauperum")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fig-list"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#fig6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.1")]), _c('span', {
    staticClass: "sp"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#fig6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The intersecting birth stories of John the Baptist and Jesus in Luke’s Gospel")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2a0",
    attrs: {
      "id": "sec2-2"
    }
  }, [_vm._v("Tables")]), _vm._v(" "), _c('p', {
    staticClass: "fig-list"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#tab3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.1")]), _c('span', {
    staticClass: "sp"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#tab3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parallel synoptic accounts of Jesus’ prayer before his arrest")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig-list"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#tab5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.1")]), _c('span', {
    staticClass: "sp"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#tab5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Threefold movement in Luke’s opening chapters")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig-list"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#tab5-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.2")]), _c('span', {
    staticClass: "sp"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#tab5-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parallelism between John the Baptist and Jesus in Luke’s opening chapters")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig-list"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#tab6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.1")]), _c('span', {
    staticClass: "sp"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#tab6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Evangelist’s use of scriptural motifs in Luke 1.68–75")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig-list"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#tab6-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.2")]), _c('span', {
    staticClass: "sp"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#tab6-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Evangelist’s use of a scriptural motif in Luke 14.7–10")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig-list"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#tab7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.1")]), _c('span', {
    staticClass: "sp"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#tab7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The pattern of movement in the Songs of Zechariah, Mary and Simeon")])])]), _vm._v(" "), _c('p', {
    staticClass: "fig-list"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#tab7-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.2")]), _c('span', {
    staticClass: "sp"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#tab7-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The context of poverty-terms in Luke’s Gospel")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c1bea58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Illustrations.vue
// module id = 72
// module chunks = 0